export default "__VITE_ASSET__CMBNaryk__"